import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { SaveMailComponent } from '../save-mail/save-mail.component';
import { MailTemplateComponent } from '../mail-template/mail-template.component';
import { EmailService } from 'src/app/services/email-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-mail-popup',
  templateUrl: './mail-popup.component.html',
  styleUrls: ['./mail-popup.component.scss']
})
export class MailPopupComponent implements OnInit, AfterViewInit {
  to: string = '';
  subject: string = '';
  message: string = '';
  cc: string = '';
  uploadedFiles: File[] = [];
  templateAttachments: any[] = [];
  combinedAttachments: any[] = [];
  isMessageManuallyEdited: boolean = false;
  isTypeComplete: boolean = false;
  ccRecipients: string = '';

  @Input() pageType: string = '';
  @ViewChild('messageInput') messageInputRef!: ElementRef<HTMLDivElement>;

  constructor(
    private dialogService: DialogService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    public emailService: EmailService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    console.log("pageType", this.pageType);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.messageInputRef && this.message) {
        this.messageInputRef.nativeElement.innerHTML = this.message;
      }
    });
  }

  popUpClose(): void {
    this.dialog.closeAll();
  }

  formatText(command: string): void {
    document.execCommand(command, false, undefined);
  }

  saveTemplate(): void {
    const templateData = {
      subject: this.subject,
      body: this.message,
      attachments: this.uploadedFiles
    };

    this.dialog.open(SaveMailComponent, {
      height: '40%',
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: templateData
    });
  }

  openMailTemplates(): void {
    const dialogRef = this.dialog.open(MailTemplateComponent, {
      height: '70%',
      width: '30%',
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: 'comment'
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.message = '';
      this.subject = '';
      this.uploadedFiles = [];
      this.templateAttachments = [];
      this.isMessageManuallyEdited = false;

      if (result) {
        this.subject = result.email_subject;
        this.message = result.email_body.replace(/\n/g, '<br>');
        this.templateAttachments = result.attachments?.Attachments || [];
        this.isTypeComplete = true;
      }

      this.updateCombinedAttachments();

      setTimeout(() => {
        if (this.messageInputRef) {
          this.messageInputRef.nativeElement.innerHTML = this.message;
        }
      });
    });
  }

  onMessageInput(event: Event): void {
    const target = event.target as HTMLElement;
    this.message = target.innerHTML.trim();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      for (let i = 0; i < input.files.length; i++) {
        this.uploadedFiles.push(input.files[i]);
      }
      this.updateCombinedAttachments();
    }
  }

  removeUploadedFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    this.updateCombinedAttachments();
  }

  updateCombinedAttachments(): void {
    this.combinedAttachments = [];

    this.templateAttachments.forEach((file: any) => {
      this.combinedAttachments.push({
        name: file.attachment_file_name,
        url: file.PreSignedUrl,
        isTemplateFile: true
      });
    });

    this.uploadedFiles.forEach((file: File, index: number) => {
      this.combinedAttachments.push({
        name: file.name,
        file: file,
        isTemplateFile: false,
        index: index
      });
    });
  }

sendEmail(): void {
  if (!this.to || !this.subject || !this.message) {
    this.snackBar.open('Please fill in all fields before sending the email.', 'Close', {
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
    return;
  }

  // Clean up message formatting
  this.message = this.message.replace(/<br\s*\/?>/gi, '\n').replace(/&nbsp;/g, ' ');

  // Prepare recipients
  const toRecipients = this.to
    .split(',')
    .map(email => email.trim())
    .filter(email => email.length > 0);
  const toString = toRecipients.join(',');

  const ccRecipients = this.cc
    ? this.cc
        .split(',')
        .map(email => email.trim())
        .filter(email => email.length > 0)
    : [];
  const ccString = ccRecipients.join(',');

  console.log('Email sent:', {
    to: toString,
    cc: ccString,
    subject: this.subject,
    message: this.message,
    attachments: this.uploadedFiles.map(file => file.name),
  });

  this.emailService.sendEmail(
    toString,
    this.subject,
    this.message,
    this.uploadedFiles,
    ccString
  )
    .then(() => {
      this.snackBar.open('Email sent successfully!', 'Close', {
        duration: 3000,
        panelClass: ['success-snackbar'],
      });

      // ✅ Reset form fields
      this.to = '';
      this.cc = '';
      this.subject = '';
      this.message = '';
      this.uploadedFiles = [];
      this.combinedAttachments = [];

      if (this.messageInputRef) {
        this.messageInputRef.nativeElement.innerHTML = ''; // clear editor
      }

      this.popUpClose();
    })
    .catch((error) => {
      console.error('Error sending email:', error);
      this.snackBar.open('Failed to send email. Please try again.', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
    });
}



}
